import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { LogIn, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login, formatApiErrorDetail } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/dashboard";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name}`);
      navigate(u.role === "admin" ? "/admin" : from, { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="container-app py-20 grid lg:grid-cols-12 gap-10" data-testid="login-page">
      <div className="lg:col-span-6 hidden lg:flex flex-col justify-center">
        <span className="section-eyebrow">Login</span>
        <h1 className="font-display text-5xl mt-4 text-navy">Welcome back to ScholarPrintHub.</h1>
        <p className="text-slate-600 mt-4">Track orders, upload files securely, view invoices, and request revisions.</p>
      </div>
      <form onSubmit={submit} className="lg:col-span-6 border border-slate-200 rounded-sm p-8 bg-white max-w-md w-full mx-auto">
        <div className="section-eyebrow">Sign in</div>
        <div className="mt-4 space-y-4">
          <div><Label className="text-xs">Email</Label><Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" /></div>
          <div><Label className="text-xs">Password</Label><Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" /></div>
        </div>
        <button type="submit" disabled={loading} data-testid="login-submit" className="btn-primary w-full mt-6">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <LogIn className="w-4 h-4" />} Sign in
        </button>
        <div className="text-xs text-slate-500 mt-4 text-center">
          New here? <Link to="/register" className="text-royal hover:underline">Create an account</Link>
        </div>
      </form>
    </div>
  );
}
